import { apiClient, makeServicePlugin, BaseModel } from "@/store/api";

class LicencingCommunicator extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = "LicencingCommunicator";

    // Define default properties here
    static instanceDefaults() {
        return {

        };
    }
}
const servicePath = "licencing-communicator";
const servicePlugin = makeServicePlugin({
    Model: LicencingCommunicator,
    service: apiClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin;
